module.exports = __webpack_public_path__ + "static/media/varal-tradicional.306d4b24.png";